import React, { useEffect, useState } from "react";

const useMobileView = () => {
  const [openMobileClass, setOpenMobileClass] = useState("");

  const handleBurgerButton = (e) => {
    if (e.target.className === "navbar-toggle") {
      setOpenMobileClass("mobile-menu-open");
    } else {
      setOpenMobileClass("");
    }
  };

  useEffect(() => {}, []);

  return [handleBurgerButton, openMobileClass];
};

export default useMobileView;
